import { forwardRef } from 'react'
import { cn } from '@/lib/cn'

export const Input = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, type = 'text', ...props }, ref) {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          'h-8 max-md:min-h-11 w-full rounded-md border border-[color:var(--input)] bg-[color:var(--card)]',
          'px-2.5 text-[13px] leading-none text-[color:var(--foreground)]',
          'placeholder:text-[color:var(--muted-foreground)]',
          'transition-colors duration-[130ms] focus-visible:outline-none focus-visible:border-[color:var(--ring)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      />
    )
  },
)
